import { WeatherCondition } from '../../../models/weather/dto/weather-forecast.dto';

/**
 * Maps weather conditions to display emojis.
 */
export const CONDITION_EMOJI: Record<WeatherCondition, string> = {
  clear: '\u2600\uFE0F',
  partly_cloudy: '\u26C5',
  cloudy: '\u2601\uFE0F',
  drizzle: '\uD83C\uDF26\uFE0F',
  rain: '\uD83C\uDF27\uFE0F',
  storm: '\u26C8\uFE0F',
  snow: '\u2744\uFE0F',
  fog: '\uD83C\uDF2B\uFE0F',
};

/**
 * Returns whether a precipitation probability indicates rain risk.
 * Threshold: >= 40%
 */
export function hasRainRisk(precipitationProbability: number): boolean {
  return precipitationProbability >= 40;
}

/**
 * Returns the emoji for a weather condition, or a default question mark for unknown.
 */
export function getConditionEmoji(condition: WeatherCondition): string {
  return CONDITION_EMOJI[condition] || '❓';
}
